var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"border",attrs:{"color":"light","height":"40","flat":"","fixed":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.toggleDrawer()}}}),_c('v-spacer'),_c('NotificationMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }